import type { JSX } from 'react';
import CustomButton from '@/components/Common/Button';
import CustomTypography from '@/components/Common/Typography';
import { ChartLaneMessage, TrackLaneMessage } from './ChartLane.styles';

const LANE_MESSAGE = {
  chart: ChartLaneMessage,
  track: TrackLaneMessage,
} as const;

interface IProps {
  message: string;
  onRetry: () => void;
  lane: keyof typeof LANE_MESSAGE;
}

export default function LaneError({ message, onRetry, lane }: IProps): JSX.Element {
  const Message = LANE_MESSAGE[lane];

  return (
    <Message>
      <CustomTypography variant="bodySmall">{message}</CustomTypography>
      <CustomButton label="Retry" variant="outline" size="small" onClick={onRetry} />
    </Message>
  );
}
